import { borgAnalytics, Button, getChannel, useTheme } from '@ytl/common-web';
import { useEffect } from 'react';
import { useLanguage } from '../../../../contexts/languageContext';
import { OnboardingStepperControls } from '../../../../modules/onboarding/OnboardingComponent';
import { getConfig } from '../../../data/config';

type HasEmailProps = {
  stepper: OnboardingStepperControls;
  email: string | null;
};

export const HasEmail = ({ email }: HasEmailProps) => {
  const { translation } = useLanguage();
  const { isWebView } = useTheme();

  const handleContinue = () => {
    if (isWebView) {
      window.location.href = getConfig().closeWebViewUrl;
    } else {
      window.location.href = getConfig().webLoginUrl;
    }
  };

  useEffect(() => {
    borgAnalytics.sendVirtualPageView({
      channel: getChannel(isWebView),
      virtualName: 'Already existing account',
    });
  }, [isWebView]);

  return (
    <div className={`onboarding-step${isWebView ? ' onboarding-step--webview' : ''}`}>
      <h2
        className="onboarding-step__header"
        style={{ textAlign: 'center' }}
      >
        {translation.onboarding.hasEmail.header}
      </h2>
      <p
        className="onboarding-step__description"
        style={{ textAlign: 'center' }}
        dangerouslySetInnerHTML={{ __html: translation.onboarding.hasEmail.description(email ? email : '#missing#') }}
      ></p>

      <div className={`onboarding-step__actions${isWebView ? ' onboarding-step__actions--webview' : ''}`}>
        <Button
          variant="contained"
          onClick={handleContinue}
        >
          {translation.onboarding.hasEmail.continue}
        </Button>
      </div>
    </div>
  );
};
